import { Component, OnChanges, SimpleChanges, ViewChild, input, output } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

import { QaiDialogComponent } from '@qai/ui';

import { SimulationTypeEnum } from 'src/app/utils/enums/self-serve/simulation-type.enum';
import { SimulationTypeOptionComponent } from './simulation-type-option/simulation-type-option.component';

@Component({
  selector: 'simulation-type-selection-modal',
  standalone: true,
  templateUrl: './simulation-type-selection-modal.component.html',
  styleUrls: ['./simulation-type-selection-modal.component.scss'],
  imports: [QaiDialogComponent, SimulationTypeOptionComponent, TranslocoModule],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'simulationBuilder' }],
})
export class SimulationTypeSelectionModalComponent implements OnChanges {
  readonly open = input(false);

  readonly typeSelected = output<SimulationTypeEnum>();
  readonly dismissed = output<void>();

  @ViewChild('dialog') dialogRef?: QaiDialogComponent;

  readonly SimulationTypeEnum = SimulationTypeEnum;

  private closedViaSelection = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      this.open() ? this.dialogRef?.showModal() : this.dialogRef?.close();
    }
  }

  handleTypeSelect(type: SimulationTypeEnum): void {
    this.closedViaSelection = true;
    this.typeSelected.emit(type);
  }

  handleCancel(event: Event): void {
    event.preventDefault();
    this.dialogRef?.close();
  }

  handleBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.dialogRef?.close();
    }
  }

  handleAfterClose(): void {
    if (this.closedViaSelection) {
      this.closedViaSelection = false;
      return;
    }
    this.dismissed.emit();
  }
}
